var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 10.0027V4.11662C17.2188 3.90665 17.1353 3.70529 16.9869 3.55683C16.8384 3.40836 16.637 3.32495 16.4271 3.32495H2.57292C2.36295 3.32495 2.16159 3.40836 2.01312 3.55683C1.86466 3.70529 1.78125 3.90665 1.78125 4.11662V14.8833C1.78125 15.0932 1.86466 15.2946 2.01312 15.4431C2.16159 15.5915 2.36295 15.675 2.57292 15.675H13.3653M1.78125 6.1892H17.2188",
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.839 16.4667V9.06348M14.839 16.4667C15.6638 16.2146 16.3983 15.7295 16.954 15.0699C17.5096 14.4102 17.8629 13.604 17.9712 12.7483C18.0245 11.988 18.02 11.2247 17.9577 10.4651C17.9494 10.3454 17.8968 10.2331 17.8101 10.1501C17.7235 10.0671 17.609 10.0194 17.4891 10.0162C16.618 10.0544 15.766 9.75318 15.1125 9.17589C15.0396 9.10412 14.9415 9.06389 14.8392 9.06389C14.7369 9.06389 14.6387 9.10412 14.5659 9.17589C13.9124 9.75318 13.0604 10.0544 12.1893 10.0162C12.0693 10.0194 11.9549 10.0671 11.8682 10.1501C11.7816 10.2331 11.7289 10.3454 11.7206 10.4651C11.6584 11.2247 11.6539 11.988 11.7071 12.7483C11.8154 13.6039 12.1686 14.4101 12.7242 15.0698C13.2798 15.7294 14.0142 16.2146 14.839 16.4667V16.4667Z",
    className: "svgStroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.9756c0f1.svg";
export { ForwardRef as ReactComponent };